import { DISABLED, MAIN_COLOUR, TEAL_PRIMARY_COLOUR } from "../../css/styles";
import { useState } from "react";

export const DropdownIcon = ({ color = MAIN_COLOUR, isDisabled = false }) => (
  <svg
    id="Dropdown"
    xmlns="http://www.w3.org/2000/svg"
    width="9.4"
    height="6.1"
    viewBox="0 0 9.4 6.1"
  >
    <path
      id="Path_36"
      data-name="Path 36"
      d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z"
      transform="translate(-2 -2)"
      fill={!isDisabled ? color : DISABLED}
    />
  </svg>
);

export const DropdownIconOpen = ({
  color = MAIN_COLOUR,
  isDisabled = false,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6.1"
    height="9.4"
    viewBox="0 0 6.1 9.4"
  >
    <g id="Dropdown" transform="translate(0 9.4) rotate(-90)">
      <path
        id="Path_36"
        data-name="Path 36"
        d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z"
        transform="translate(-2 -2)"
        fill={!isDisabled ? color : DISABLED}
      />
    </g>
  </svg>
);

export const DropdownIconMobile = ({
  color = MAIN_COLOUR,
  isDisabled = false,
}) => (
  <svg
    id="Dropdown"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="9"
    viewBox="0 0 9.4 6.1"
  >
    <path
      id="Path_36"
      data-name="Path 36"
      d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z"
      transform="translate(-2 -2)"
      fill={!isDisabled ? color : DISABLED}
    />
  </svg>
);

export const DropdownIconOpenMobile = ({
  color = MAIN_COLOUR,
  isDisabled = false,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="15"
    viewBox="0 0 6.1 9.4"
  >
    <g id="Dropdown" transform="translate(0 9.4) rotate(-90)">
      <path
        id="Path_36"
        data-name="Path 36"
        d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z"
        transform="translate(-2 -2)"
        fill={!isDisabled ? color : DISABLED}
      />
    </g>
  </svg>
);

export const NavigationArrowRight = () => {
  const [isOnHover, setIsOnHover] = useState(false);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.086"
      height="26.33"
      viewBox="0 0 17.086 26.33"
      className="clickable"
      onMouseEnter={() => setIsOnHover(true)}
      onMouseLeave={() => setIsOnHover(false)}
    >
      <g id="Dropdown" transform="translate(0 26.33) rotate(-90)">
        <path
          id="Path_36"
          data-name="Path 36"
          d="M15.165,19.086,2,5.921,5.921,2l9.243,9.243L24.408,2,28.33,5.921Z"
          transform="translate(-2 -2)"
          fill={isOnHover ? MAIN_COLOUR : TEAL_PRIMARY_COLOUR}
        />
      </g>
    </svg>
  );
};

export const NavigationArrowLeft = () => {
  const [isOnHover, setIsOnHover] = useState(false);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.086"
      height="26.33"
      viewBox="0 0 17.086 26.33"
      className="clickable"
      onMouseEnter={() => setIsOnHover(true)}
      onMouseLeave={() => setIsOnHover(false)}
    >
      <g id="Dropdown" transform="translate(17.086) rotate(90)">
        <path
          id="Path_36"
          data-name="Path 36"
          d="M15.165,19.086,2,5.921,5.921,2l9.243,9.243L24.408,2,28.33,5.921Z"
          transform="translate(-2 -2)"
          fill={isOnHover ? MAIN_COLOUR : TEAL_PRIMARY_COLOUR}
        />
      </g>
    </svg>
  );
};

export const MapMarkerIcon = () => {
  const [isOnHover, setIsOnHover] = useState(false);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.726"
      height="23.092"
      viewBox="0 0 18.726 28.092"
      className="clickable"
      onMouseEnter={() => setIsOnHover(true)}
      onMouseLeave={() => setIsOnHover(false)}
    >
      <g id="iconfinder_map-marker_299087" transform="translate(-3.5 -1027.9)">
        <path
          id="Path_211"
          data-name="Path 211"
          d="M12.863,0a8.843,8.843,0,0,0-7.72,13.19c.12.213.245.422.381.624l7.339,12.775L20.2,13.814c.113-.167.21-.345.311-.52l.07-.1A8.843,8.843,0,0,0,12.863,0Zm0,4.431A4.431,4.431,0,1,1,8.431,8.863,4.432,4.432,0,0,1,12.863,4.431Z"
          transform="translate(0 1028.4)"
          fill={isOnHover ? MAIN_COLOUR : "none"}
          stroke="#022444"
          strokeWidth="1"
        />
        <path
          id="Path_212"
          data-name="Path 212"
          d="M12.539,3a5.539,5.539,0,1,0,5.539,5.539A5.539,5.539,0,0,0,12.539,3Zm0,2.216A3.324,3.324,0,1,1,9.216,8.539,3.323,3.323,0,0,1,12.539,5.216Z"
          transform="translate(0.324 1028.723)"
          fill={isOnHover ? MAIN_COLOUR : "none"}
        />
      </g>
    </svg>
  );
};

export const ContactDetailsNameIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="14"
      viewBox="0 0 20 14"
      className="contact-details-item"
    >
      <path
        id="Path_464"
        data-name="Path 464"
        d="M9,13.75c-2.34,0-7,1.17-7,3.5V19H16V17.25C16,14.92,11.34,13.75,9,13.75ZM4.34,17A9.642,9.642,0,0,1,9,15.75,9.642,9.642,0,0,1,13.66,17ZM9,12A3.5,3.5,0,1,0,5.5,8.5,3.5,3.5,0,0,0,9,12ZM9,7A1.5,1.5,0,1,1,7.5,8.5,1.5,1.5,0,0,1,9,7Zm7.04,6.81A4.193,4.193,0,0,1,18,17.25V19h4V17.25C22,15.23,18.5,14.08,16.04,13.81ZM15,12a3.5,3.5,0,0,0,0-7,3.446,3.446,0,0,0-1.5.35,5.461,5.461,0,0,1,0,6.3A3.446,3.446,0,0,0,15,12Z"
        transform="translate(-2 -5)"
        fill="#022444"
      />
    </svg>
  );
};

export const ContactDetailsEmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      className="contact-details-item"
    >
      <path
        id="Path_465"
        data-name="Path 465"
        d="M22,6a2.006,2.006,0,0,0-2-2H4A2.006,2.006,0,0,0,2,6V18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2ZM20,6l-8,5L4,6Zm0,12H4V8l8,5,8-5Z"
        transform="translate(-2 -4)"
        fill="#022444"
      />
    </svg>
  );
};

export const ContactDetailsPhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      className="contact-details-item"
    >
      <path
        id="Path_466"
        data-name="Path 466"
        d="M6.54,5a12.312,12.312,0,0,0,.45,2.59l-1.2,1.2A14.826,14.826,0,0,1,5.03,5H6.54M16.4,17.02a12.753,12.753,0,0,0,2.6.45v1.49a15.426,15.426,0,0,1-3.8-.75l1.2-1.19M7.5,3H4A1,1,0,0,0,3,4,17,17,0,0,0,20,21a1,1,0,0,0,1-1V16.51a1,1,0,0,0-1-1,11.407,11.407,0,0,1-3.57-.57.839.839,0,0,0-.31-.05,1.024,1.024,0,0,0-.71.29l-2.2,2.2a15.149,15.149,0,0,1-6.59-6.59l2.2-2.2a1,1,0,0,0,.25-1.02A11.36,11.36,0,0,1,8.5,4,1,1,0,0,0,7.5,3Z"
        transform="translate(-3 -3)"
        fill="#022444"
      />
    </svg>
  );
};

export const ContactDetailsAddressIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.936"
      height="17.904"
      viewBox="0 0 11.936 17.904"
      className="contact-details-item"
    >
      <g id="iconfinder_map-marker_299087" transform="translate(-4 -1028.4)">
        <path
          id="Path_211"
          data-name="Path 211"
          d="M9.968,0a5.954,5.954,0,0,0-5.2,8.882c.08.143.165.284.256.42l4.942,8.6L14.91,9.3c.076-.113.142-.232.21-.35l.047-.07A5.955,5.955,0,0,0,9.968,0Zm0,2.984A2.984,2.984,0,1,1,6.984,5.968,2.984,2.984,0,0,1,9.968,2.984Z"
          transform="translate(0 1028.4)"
          fill="#022444"
        />
        <path
          id="Path_212"
          data-name="Path 212"
          d="M10.73,3a3.73,3.73,0,1,0,3.73,3.73A3.73,3.73,0,0,0,10.73,3Zm0,1.492A2.238,2.238,0,1,1,8.492,6.73,2.238,2.238,0,0,1,10.73,4.492Z"
          transform="translate(-0.762 1027.638)"
          fill="#022444"
        />
      </g>
    </svg>
  );
};

export const ContactDetailsWebsiteLink = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.733"
      height="13.445"
      viewBox="0 0 18.733 13.445"
      className="contact-details-item"
    >
      <g id="_1" data-name="1" transform="translate(-54.151 -103.302)">
        <path
          id="Path_337"
          data-name="Path 337"
          d="M58.583,149.233a4.432,4.432,0,0,1-3.135-7.565l3-3a4.439,4.439,0,0,1,6.27,0h0a4.439,4.439,0,0,1,0,6.27l-3,3A4.42,4.42,0,0,1,58.583,149.233Zm3-10.474a3.03,3.03,0,0,0-2.152.89l-3,3a3.042,3.042,0,0,0,4.3,4.3l3-3a3.04,3.04,0,0,0-2.151-5.19Z"
          transform="translate(0 -32.486)"
          fill="#022444"
        />
        <path
          id="Path_338"
          data-name="Path 338"
          d="M204.874,115.248a4.409,4.409,0,0,1-1.12-.144.7.7,0,0,1,.353-1.346,3.041,3.041,0,0,0,2.918-.793l3-3a3.041,3.041,0,1,0-4.3-4.3l-3,3a3.056,3.056,0,0,0-.793,2.919.7.7,0,0,1-1.346.35,4.452,4.452,0,0,1,1.156-4.253l3-3a4.433,4.433,0,1,1,6.269,6.268l-3,3a4.405,4.405,0,0,1-3.135,1.3Z"
          transform="translate(-139.504)"
          fill="#022444"
        />
      </g>
    </svg>
  );
};
